if (!customElements.get('review-stars')) {
  class ReviewStars extends HTMLElement {
    constructor() {
      super()

      this.fetchReviews()
    }

    render(data) {
      const $count = this.querySelector('[data-count]')
      if ($count) $count.textContent = data.count

      const $rating = this.querySelector('[data-rating]')
      if ($rating) $rating.textContent = data.rating

      const ratingPercent = (data.rating / 5) * 100
      const $stars = this.querySelector('svg:nth-child(2)')
      if ($stars) $stars.style.clipPath = `polygon(0 0, ${ratingPercent}% 0, ${ratingPercent}% 100%, 0 100%)`
    }

    fetchReviews() {
      const productId = this.getAttribute('product-id')
      const storageKey = `reviews-stars:${productId}`

      const cachedReviews = sessionStorage.getItem(storageKey)
      if (cachedReviews) {
        const data = JSON.parse(cachedReviews)
        this.render(data)
        return
      }

      fetch('https://stamped.io/api/widget/badges', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productIds: [
            {
              productId: this.getAttribute('product-id'),
            },
          ],
          apiKey: 'pubkey-mm3fdDr731rZE1b58X4y17wn07CrvB',
          storeUrl: 'irestore-4.myshopify.com',
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.length > 0) {
            const _data = {
              count: data[0].count,
              rating: Number.parseFloat(data[0].rating.toFixed(1)),
            }
            this.render(_data)
            // Cache the data
            sessionStorage.setItem(storageKey, JSON.stringify(_data))
          }
        })
    }
  }

  customElements.define('review-stars', ReviewStars)
}
